import { serializedErrorToWebDataError, WebData, webDataLoading, webDataNotAsked, webDataSuccess } from "@lvt/web-data";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { fetchCameraData } from "@/api/cameras";

import { CameraNavigation } from "../userLists/types";


export interface camerasState {
    streamingId: null | number;
    cameraList: WebData<CameraNavigation[]>;
}

type setStreamingCameraPayload = number;

const initialState: camerasState = {
    streamingId: null,
    cameraList: webDataNotAsked(),
};

const camerasSlice = createSlice({
    name: "cameras",
    initialState,
    reducers: {
        setStreamingCamera(state, action: PayloadAction<setStreamingCameraPayload>) {
            state.streamingId = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCameraData.pending, (state) => {
                state.cameraList = webDataLoading();
            })
            .addCase(fetchCameraData.fulfilled, (state, action) => {
                state.cameraList = webDataSuccess(action.payload);
            })
            .addCase(fetchCameraData.rejected, (state, action) => {
                state.cameraList = serializedErrorToWebDataError(action.error);
            });
    },
});

export const { setStreamingCamera } = camerasSlice.actions;
export const camerasReducer = camerasSlice.reducer;
